import { render, staticRenderFns } from "./TypographyControls.vue?vue&type=template&id=81f264ba&scoped=true&"
import script from "./TypographyControls.vue?vue&type=script&lang=js&"
export * from "./TypographyControls.vue?vue&type=script&lang=js&"
import style0 from "./TypographyControls.vue?vue&type=style&index=0&id=81f264ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f264ba",
  null
  
)

export default component.exports